import i18next from 'i18next';
import en from '../locales/en.json';
import nl from '../locales/nl.json';
import es from '../locales/es.json';

const LANGUAGES = ['en', 'nl', 'es'];
const params = new URLSearchParams(window.location.search);
const savedLang = params.get('lang') || localStorage.getItem('i18nextLng') || 'en';

i18next
  .init({
    lng: savedLang,
    resources: {
      en: { translation: en },
      nl: { translation: nl },
      es: { translation: es },
    },
    supportedLngs: LANGUAGES,
    load: 'languageOnly',
    fallbackLng: 'en',
  })
  .then(() => {
    updateContent();
    updateToggle();
    setProfile(document.body.dataset.profile);
  });

function updateContent() {
  document.querySelectorAll('[data-i18n]').forEach((el) => {
    const key = el.getAttribute('data-i18n');
    const val = i18next.t(key);
    if (val && val !== key) {
      el.textContent = val;
    }
  });
}

function updateToggle() {
  const active = i18next.resolvedLanguage;
  document.documentElement.lang = active;
  document.querySelectorAll('[data-lang]').forEach((button) => {
    button.setAttribute('aria-pressed', String(button.dataset.lang === active));
  });
}

function setLanguage(lang) {
  i18next.changeLanguage(lang).then(() => {
    localStorage.setItem('i18nextLng', lang);
    updateContent();
    updateToggle();
  });
}

// CV profiles: ?profile=legal|security|engineering picks which items show (see the CSS in resume.html),
// and ?lang=en|nl|es the language, so a tailored CV can be shared as one link.
// No visible switcher: the default (legal) is the public CV, the others are shared by link.
const PROFILES = ['legal', 'security', 'engineering'];

function setProfile(profile) {
  const active = PROFILES.includes(profile) ? profile : PROFILES[0];
  document.body.dataset.profile = active;
  // The title becomes the default file name when saving as PDF
  if (i18next.isInitialized) {
    document.title = `Juan Idrovo - CV - ${i18next.t(`resume.profiles.${active}`)}`;
  }
}

setProfile(params.get('profile'));
i18next.on('languageChanged', () => setProfile(document.body.dataset.profile));

// Attach event listeners (replaces inline onclick handlers)
document.querySelectorAll('[data-lang]').forEach((button) => {
  button.addEventListener('click', () => setLanguage(button.dataset.lang));
});
document.getElementById('save-pdf-btn').addEventListener('click', () => window.print());
